import { FC } from 'react'
import styles from './PolygonBanner.module.scss'
import { UiAppearance } from '~/modules/UiVariant/appearance'

interface Props {
  appearance?: UiAppearance
}

export const PolygonBanner: FC<Props> = ({ appearance = 'default' }) => {
  return (
    <section
      className={ `
        ${styles.polygonBanner__container}
        ${appearance === 'museumHome' ? styles.museumHome : ''}
      ` }
    >
      <img
        className={ styles.polygonBanner__image }
        src="/img/banner/polygon-banner.png"
        alt="Powered by Polygon"
        lang="en"
      />
    </section>
  )
}
